/**
 * Decodes the base64-encoded `data` returned by GetArtifactContent into a
 * UTF-8 string. The generated TS type calls it `data?: string` but the wire
 * payload is base64.
 */
export function decodeArtifactData(data?: string): string {
  if (!data) return '';
  const binary = atob(data);
  const bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
  return new TextDecoder('utf-8').decode(bytes);
}
